import { motion } from "framer-motion";
import { ExternalLink, Facebook, Instagram } from "lucide-react";

const CHANNELS = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/be_parent.de",
    handle: "@be_parent.de",
    icon: Instagram,
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@beparent.app",
    handle: "@beparent.app",
    icon: TikTokIcon,
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61594332770784",
    handle: "BeParent",
    icon: Facebook,
  },
];

export default function SocialMedia() {
  return (
    <section
      aria-labelledby="social-media-title"
      data-testid="social-media-section"
      className="relative py-20 md:py-28"
    >
      <div className="max-w-[1100px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-4 mb-10">
          <span className="font-mono-bp text-[11px] tracking-[0.35em] uppercase text-[#00FAF8]">
            BeParent begleiten
          </span>
          <span className="flex-1 h-px bg-gradient-to-r from-[#00FAF8]/40 via-white/10 to-transparent" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-end">
          <div className="lg:col-span-4">
            <h2
              id="social-media-title"
              className="font-display text-white text-3xl md:text-4xl leading-tight tracking-[-0.03em] font-medium"
            >
              Einblicke in die Entwicklung.
            </h2>
            <p className="mt-4 text-white/60 text-base leading-relaxed max-w-lg">
              Neuigkeiten, Einblicke in die Entwicklung und Informationen rund
              um BeParent.
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-3">
            {CHANNELS.map(({ name, href, handle, icon: Icon }, index) => (
              <motion.a
                key={name}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${name}-Profil von BeParent in einem neuen Tab öffnen`}
                data-testid={`social-link-${name.toLowerCase()}`}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ delay: index * 0.08, duration: 0.6 }}
                className="group min-h-20 flex items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-4 outline-none transition-colors hover:border-[#00FAF8]/45 hover:bg-[#00FAF8]/[0.06] focus-visible:border-[#00FAF8] focus-visible:ring-2 focus-visible:ring-[#00FAF8]/30"
              >
                <span className="shrink-0 inline-flex h-10 w-10 items-center justify-center rounded-xl border border-[#00FAF8]/20 bg-[#00FAF8]/[0.07] text-[#00FAF8] transition-colors group-hover:border-[#00FAF8]/45">
                  <Icon size={19} aria-hidden />
                </span>
                <span className="min-w-0">
                  <span className="block text-sm font-medium text-white/90">
                    {name}
                  </span>
                  <span className="block break-words text-[11px] font-mono-bp text-white/40">
                    {handle}
                  </span>
                </span>
                <ExternalLink
                  size={14}
                  aria-hidden
                  className="ml-auto shrink-0 text-white/30 transition-colors group-hover:text-[#00FAF8]"
                />
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function TikTokIcon({ size = 19, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M15 4v10.25a5.25 5.25 0 1 1-4.5-5.2" />
      <path d="M15 4c.35 2.35 1.65 3.72 4 4.1" />
    </svg>
  );
}
